export const measurementsOptions =
    [
        {"id": "back_bar", "name": "Back Bar", "value": 0},
        {"id": "brackets", "name": "Brackets", "value": 0},
        {"id": "fabric", "name": "Fabric", "value": 0},
        {"id": "curtain_fabric", "name": "Curtain Fabric", "value": 0},
        {"id": "fabric_cutting_clearance", "name": "Fabric Cutting Clearance", "value": 0},
        {"id": "alu_back_bar_cutting_clearance", "name": "Alu Back Bar Cutting Clearance", "value": 0},
        {"id": "alu_cover_cutting_clearance", "name": "Alu Cover Cutting Clearance", "value": 0},
        {"id": "top_tube_cutting_clearance", "name": "Top Tube Gear Cutting Clearance", "value": 0},
        {"id": "top_tube_batt_motor_cutting_clearance", "name": "Top Tube Batt Motor Cutting Clearance", "value": 0},
        {
            "id": "top_tube_electric_motor_cutting_clearance",
            "name": "Top Tube Electric Motor Cutting Clearance",
            "value": 0
        },
        {"id": "plastic_bottom_cutting_clearance", "name": "Plastic Bottom Cutting Clearance", "value": 0},
        {"id": "aluminium_bottom_cutting_clearance", "name": "Aluminium Bottom Cutting Clearance", "value": 0},
        {"id": "bottom_bar_fabric_wrap", "name": "Bottom Bar Fabric Wrap", "value": 0},
        {"id": "top_tube_fabric_wrap", "name": "Top Tube Fabric Wrap", "value": 0},
        {"id": "alum_outer_bottom_cutting_clearance", "name": "Alum Outer Bottom Cutting Clearance", "value": 0},
        {"id": "alum_inner_bottom_cutting_clearance", "name": "Alum Inner Bottom Cutting Clearance", "value": 0},
        {"id": "alum_rail_cutting_clearance", "name": "Alum Rail Cutting Clearance", "value": 0},
        {"id": "three_way_tilt_rod_cutting_length", "name": "3 Way Tilt Rod Cutting Length", "value": 0},
        {"id": "gear_and_top_tube", "name": "Gear / Top Tube Default", "value": 0},
        {"id": "gear_and_top_tube_optional", "name": "Gear / Top Tube Optional", "value": 0},
        {"id": "cover", "name": "Cover", "value": 0},
        {"id": "metal_head_rail_cutting_clearance", "name": "Metal Head Rail Cutting Clearance", "value": 0},
        {"id": "metal_bottom_cutting_clearance", "name": "Metal Bottom Cutting Clearance", "value": 0},
        {"id": "wind_stop_set_cutting_clearance", "name": "Wind Stop Set Cutting Clearance", "value": 0},
        {"id": "extra_fabric_cutting_clearance", "name": "Extra Fabric Cutting Clearance (Over 240cm Drop)", "value": 0},
    ]

function roundToOneDecimalPlace(num) {
    return Math.round(num * 10) / 10;
}

export function returnMeasurements(item) {
    let fixingType = item?.attributes?.options[0]?.fixing_type
    const blindType = item.attributes.type
    const recessType = item.attributes.options[0].recess_type?.toLowerCase().includes('outside') ? 'outside' : 'inside'
    const controlType = item?.attributes?.options?.[0]?.control_type ? item.attributes.options[0].control_type.toLowerCase().includes('cord') ? 'cord' : 'wand' : undefined
    const itemOptions = item.attributes.options[0]
    const blindOptionsType = item.attributes.options[0]?.type
    let tempMeasurements

  if (!item.attributes.measurements) {
  console.log("Nothing here")
    return []

  }

    if (fixingType && fixingType.includes('aluminium_back_bar')) {
        tempMeasurements = item.attributes.measurements.back_bar
    } else if (fixingType && fixingType.includes('brackets')) {
        tempMeasurements = item.attributes.measurements.brackets
    } else if (fixingType && fixingType.includes('aluminium_cover')) {
        tempMeasurements = item.attributes.measurements.cover
    } else if (controlType && controlType.includes('cord')) {
        tempMeasurements = item.attributes.measurements.cord
    } else if (controlType && controlType.includes('wand')) {
        tempMeasurements = item.attributes.measurements.wand
    } else if (!fixingType && item?.attributes?.measurements?.general) {
        tempMeasurements = item.attributes.measurements.general
    }

    if (!fixingType && !tempMeasurements && itemOptions?.aluminium_cover) {
        if (itemOptions.aluminium_cover.toLowerCase().includes('with cover')) {
            fixingType = 'aluminium_cover'
            tempMeasurements = item.attributes.measurements.cover
        } else if (itemOptions.aluminium_cover.toLowerCase().includes('without cover')) {
            fixingType = 'aluminium_back_bar'
            tempMeasurements = item.attributes.measurements.back_bar
        }
    }

    tempMeasurements = convertMeasurementsToObject(tempMeasurements)
    return returnPrintingArray(itemOptions, tempMeasurements, {fixingType, blindType, recessType, controlType, blindOptionsType})
}

function convertMeasurementsToObject(arr) {
    return arr.reduce((obj, item) => {
        obj[item.id] = item.value;
        return obj;
    }, {});
}

function returnPrintingArray(options, measurements, config) {
    const {fixingType, blindType, recessType, controlType, blindOptionsType} = config

    console.log(fixingType, blindType, recessType, controlType, blindOptionsType)
    const printingArray = []

    const finalBlindArray = recessType === 'inside' ? returnInsideFinalBlindArray(options) : returnOutsideFinalBlindArray(options)
    if (finalBlindArray.length) printingArray.push({width: 'two', values: finalBlindArray})

    const aluminiumCuttingArray = returnAluminiumArray(options, measurements, blindType, recessType, fixingType, controlType)
    if (aluminiumCuttingArray.length) printingArray.push({width: 'two', values: aluminiumCuttingArray})

    if (blindType.includes('roller') || blindType.includes('zebra')) {
        const fabricArray = returnFabricArray(options, measurements, blindType, recessType, fixingType)
        if (fabricArray.length) printingArray.push({width: 'two', values: fabricArray})
    }

    if (controlType === 'cord' || blindType.includes('vertical')) {
        const cordArray = returnCordArray(options, blindType, recessType, measurements)
        if (cordArray.length) printingArray.push({width: 'two', values: cordArray})

        const chainArray = returnChainArray(options, recessType, blindOptionsType)
        if (chainArray.length && blindOptionsType !== 'Fabric Only') printingArray.push({width: 'two', values: chainArray})
    }

    if (controlType === 'wand') {
        const wandArray = returnWandArray(options, blindType, recessType, measurements)
        if (wandArray.length) printingArray.push({width: 'two', values: wandArray})
    }

    if (blindType.includes('venetian')) {
        const venetianMeasurementsArray = returnVenetianMeasurementsArray(options, measurements, blindType, recessType, fixingType)
        if (venetianMeasurementsArray.length) printingArray.push({width: 'two', values: venetianMeasurementsArray})

    }

    return printingArray
}

function removeNullValuesFromPrintingArray(arr) {
    return arr.map(x => ({...x, values: x.values.filter((y => y !== null))}))
}

function returnFinalBlindWidth(options, recessType) {
    return recessType.includes('outside') ? parseFloat(options.width) + parseFloat(options.overlap_width) : parseFloat(options.width) - parseFloat(options.width_clearance)
}

function returnFinalBlindDrop(options, recessType) {
    return recessType.includes('outside') ? parseFloat(options.drop) + parseFloat(options.overlap_drop) : parseFloat(options.drop)
}

function returnOutsideFinalBlindArray(options) {
    const finalBlindArray = []
    if (options.width != null && options.overlap_width != null) finalBlindArray.push({
        title: 'Final Blind Width',
        unit: 'cm',
        value: roundToOneDecimalPlace(parseFloat(options.width) + parseFloat(options.overlap_width))
    })
    if (options.drop) finalBlindArray.push({
        title: 'Final Blind Drop',
        unit: 'cm',
        value: roundToOneDecimalPlace(parseFloat(options.drop) + parseFloat(options.overlap_drop))
    })

    return finalBlindArray
}

function returnInsideFinalBlindArray(options) {
    const finalBlindArray = []
    if (options.width != null && options.width_clearance != null) finalBlindArray.push({
        title: 'Final Blind Width',
        unit: 'cm',
        value: roundToOneDecimalPlace(parseFloat(options.width) - parseFloat(options.width_clearance))
    })
    if (options.drop) finalBlindArray.push({
        title: 'Final Blind Drop',
        unit: 'cm',
        value: roundToOneDecimalPlace(parseFloat(options.drop))
    })

    return finalBlindArray
}

function returnAluminiumMeasurement(options, recessType, title, toSubtract) {
    return recessType.includes('outside') ? returnOutsideAluminiumCuttingMeasurement(options, title, toSubtract) : returnInsideAluminiumCuttingMeasurement(options, title, toSubtract)
}

function getBottomCuttingClearance(options, measurements) {
    if (options.bottom_bar && options.bottom_bar.toLowerCase().includes('pvc')) {
        return measurements.plastic_bottom_cutting_clearance
    }

    if (options.bottom_bar && options.bottom_bar.toLowerCase().includes('aluminium')) {
        return measurements.aluminium_bottom_cutting_clearance
    }

    return undefined
}

function getTopTubeCuttingClearance(options, measurements) {
    if (options.motor && options.motor.toLowerCase().includes('battery')) {
        return measurements.top_tube_batt_motor_cutting_clearance ? measurements.top_tube_batt_motor_cutting_clearance : 0
    } else if (options.motor && options.motor.toLowerCase().includes('electrical')) {
        return measurements.top_tube_electric_motor_cutting_clearance ? measurements.top_tube_electric_motor_cutting_clearance : 0
    } else {
        return measurements.top_tube_cutting_clearance
    }
}

function returnInsideZebraRollerBottomBar(options, measurements, blindType, recessType, fixingType, measurementType) {
    let bottomCuttingClearance
    let titleToReturn
    let bottomCuttingClearanceType

    bottomCuttingClearanceType = getBottomCuttingClearance(options, measurements)

    if (blindType.includes('roller')) {
            if (options.tile_cut_width) {
               return getRollerBottomMeasurmentWithTileCut(options)
            }
        bottomCuttingClearance = bottomCuttingClearanceType ? bottomCuttingClearanceType : measurements.plastic_bottom_cutting_clearance
        titleToReturn = 'Bottom Bar'

    } else if (blindType.includes('zebra')) {
        if (measurementType === 'outer_bottom') {
          if (options.tile_cut_width) {
            return getZebraOuterBottomMeasurmentWithTileCut(options, measurements)
          }
            bottomCuttingClearance = measurements.alum_outer_bottom_cutting_clearance
            titleToReturn = 'Outer Bottom'
        }
        if (measurementType === 'inner_bottom') {
            if (options.tile_cut_width) {
               return getZebraInnerBottomMeasurmentWithTileCut(options, measurements)
            }
            bottomCuttingClearance = measurements.alum_inner_bottom_cutting_clearance
            titleToReturn = 'Inner Bottom'
        }
    }
    let tempTileCutWidth = options.tile_cut_width ? options.tile_cut_width : 0
    let tempTileCutWidthClearance = options.tile_cut_width_clearance ? options.tile_cut_width_clearance : 0

    const G28 = parseFloat(tempTileCutWidth) - parseFloat(tempTileCutWidthClearance)
    const G29 = (parseFloat(options.width) - parseFloat(options.width_clearance)) - parseFloat(bottomCuttingClearance)

    let answer
    if ((parseFloat(tempTileCutWidth) - parseFloat(tempTileCutWidthClearance)) <= 0 || (parseFloat(tempTileCutWidth) - parseFloat(tempTileCutWidthClearance)) > G29) {
        answer = G29;
    } else {
        answer = G28;
    }

    return ({
        title: titleToReturn,
        unit: 'cm',
        value: roundToOneDecimalPlace(parseFloat(answer))
    })
}

function getRollerBottomMeasurmentWithTileCut(options) {
  return ({
      title: 'Bottom Bar',
      unit: 'cm',
      value: roundToOneDecimalPlace(getZebraBottomMeasurmentWithTileCut(0.4, options))
  })
}


function getZebraOuterBottomMeasurmentWithTileCut(options) {
  return ({
      title: 'Outer Bottom',
      unit: 'cm',
      value: roundToOneDecimalPlace(getZebraBottomMeasurmentWithTileCut(1.4, options))
  })
}

function getZebraInnerBottomMeasurmentWithTileCut(options) {
  return ({
      title: 'Inner Bottom',
      unit: 'cm',
      value: roundToOneDecimalPlace(getZebraBottomMeasurmentWithTileCut(1.1, options))
  })
}

function  getZebraBottomMeasurmentWithTileCut(innerBottomEndCapClearance, options) {
  const tileCutWidthClearance = parseFloat(options.tile_cut_width_clearance)
  return (options.tile_cut_width - (tileCutWidthClearance + innerBottomEndCapClearance))
}

function returnOutsideAluminiumCuttingMeasurement(options, title, toSubtract) {
    if (options.width == null || options.overlap_width == null || toSubtract == null) return null
    return ({
        title: title,
        unit: 'cm',
        value: roundToOneDecimalPlace(parseFloat(options.width) + parseFloat(options.overlap_width) - parseFloat(toSubtract))
    })
}

function returnInsideAluminiumCuttingMeasurement(options, title, toSubtract) {
    if (options.width == null || options.width_clearance == null || toSubtract == null) return null
    return ({
        title: title,
        unit: 'cm',
        value: roundToOneDecimalPlace(parseFloat(options.width) - parseFloat(options.width_clearance) - parseFloat(toSubtract))
    })
}

function returnGearAndTopTube(options, measurements, blindType, recessType) {
    const currentMotor = options.motor
    let gearValue
    let widthToCalculate = recessType.includes('outside')
        ? parseFloat(options.width) + parseFloat(options.overlap_width)
        : parseFloat(options.width) - parseFloat(options.width_clearance)
    if (blindType.includes('roller_blind_1') || (blindType.includes('zebra_blind') && !blindType.includes('zebra_blind_2'))) {
        gearValue = measurements.gear_and_top_tube1
    } else if (blindType.includes('roller_blind_2')) {
        gearValue = measurements.gear_and_top_tube
    } else if (blindType.includes('roller_blind_3') || blindType.includes('zebra_blind_2')) {
        if (currentMotor && currentMotor.toLowerCase().includes('battery') && widthToCalculate <= 240) {
            gearValue = measurements.gear_and_top_tube_optional
        } else {
            gearValue = measurements.gear_and_top_tube
        }
    }

    return gearValue
}

function returnAluminiumArray(options, measurements, blindType, recessType, fixingType, controlType) {
    const aluminiumArray = []
    if (blindType.includes('roller')) {
        let tempGearAndTopTube = returnGearAndTopTube(options, measurements, blindType, recessType, fixingType)
        if (tempGearAndTopTube) {
            aluminiumArray.push({
                title: 'Gear / Top Tube',
                value: tempGearAndTopTube
            })
            aluminiumArray.push({
                title: '',
                value: '',
            })
        }
        aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Top Tube', getTopTubeCuttingClearance(options, measurements)))

        let bottomCuttingClearanceType
        bottomCuttingClearanceType = getBottomCuttingClearance(options, measurements)


        if (recessType.includes('inside')) aluminiumArray.push(returnInsideZebraRollerBottomBar(options, measurements, blindType, recessType, fixingType, 'roller'))
        else aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Bottom Bar', bottomCuttingClearanceType ? bottomCuttingClearanceType : measurements.plastic_bottom_cutting_clearance))

        if (fixingType.includes('back')) aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Alum Back Bar', measurements.alu_back_bar_cutting_clearance))
        if (fixingType.includes('cover')) aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Alum Cover', measurements.alu_cover_cutting_clearance))
    }

    if (blindType.includes('zebra')) {
        let tempGearAndTopTube = returnGearAndTopTube(options, measurements, blindType, recessType, fixingType)
        if (tempGearAndTopTube) {
            aluminiumArray.push({
                title: 'Gear / Top Tube',
                value: tempGearAndTopTube
            })
            aluminiumArray.push({
                title: '',
                value: '',
            })
        }
        if (fixingType.includes('back')) aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Alum Back Bar', measurements.alu_back_bar_cutting_clearance))
        if (fixingType.includes('cover')) aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Alum Cover', measurements.alu_cover_cutting_clearance))
        aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Top Tube', getTopTubeCuttingClearance(options, measurements)))

      if (recessType.includes('inside')) {
        aluminiumArray.push(returnInsideZebraRollerBottomBar(options, measurements, blindType, recessType, fixingType, 'inner_bottom'))
      }
      else {
        aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Inner Bottom', measurements.alum_inner_bottom_cutting_clearance))
      }

        if (recessType.includes('inside')) aluminiumArray.push(returnInsideZebraRollerBottomBar(options, measurements, blindType, recessType, fixingType, 'outer_bottom'))
        else aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Outer Bottom', measurements.alum_outer_bottom_cutting_clearance))
    }

    if (blindType.includes('vertical')) {
        aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Alum Rail', measurements.alum_rail_cutting_clearance))
        aluminiumArray.push({
            title: '3-Way Tilt Rod',
            unit: 'cm',
            value: roundToOneDecimalPlace(returnThreeWayTiltRod(options, measurements, recessType))
        })
    }

    if (blindType.includes('curtain')) {
        aluminiumArray.push(returnAluminiumMeasurement(options, recessType, 'Alum Rail', measurements.alum_rail_cutting_clearance))
        aluminiumArray.push({
            title: '3-Way Tilt Rod',
            unit: 'cm',
            value: roundToOneDecimalPlace(returnThreeWayTiltRod(options, measurements, recessType))
        })
    }

    if (blindType.includes('curtain') && controlType === 'wand') {
        const apertureTypeWandValue = options.aperture_type === 'door' ? 150 : 100
        aluminiumArray.push({
            title: 'Wand',
            unit: 'cm',
            value: apertureTypeWandValue
        })
    }

    return aluminiumArray
}

function returnThreeWayTiltRod(options, measurements, recessType) {
    return recessType.includes('outside') ?
        parseFloat(options.width) + parseFloat(options.overlap_width) + parseFloat(measurements.three_way_tilt_rod_cutting_length) :
        (parseFloat(options.width) - parseFloat(options.width_clearance) - parseFloat(measurements.alum_rail_cutting_clearance)) + parseFloat(measurements.three_way_tilt_rod_cutting_length)
}

function returnInsideRollerFabricWidth(options, measurements) {
 return options.tile_cut_width
  ? returnRollerFabricWidthWithTileCut(options, measurements)
  : returnRollerFabricWidthWithoutTileCut(options, measurements)
}

function returnRollerFabricWidthWithoutTileCut(options, measurements) {
  let totalClearance =  parseFloat(options.width_clearance) + parseFloat(measurements.fabric_cutting_clearance)
  const requiresExtraFabricCuttingClearance = parseFloat(options.drop) >= 240;
  if (requiresExtraFabricCuttingClearance) {
    totalClearance += parseFloat(measurements.extra_fabric_cutting_clearance)
  }
  return roundToOneDecimalPlace(parseFloat(options.width) - totalClearance);
}

function returnRollerFabricWidthWithTileCut(options, measurements) {
  const bottomEndCapClearance = 0.4
  let materialClearance = measurements.aluminium_bottom_cutting_clearance
  if (options.bottom_bar.includes("PVC")) {
    materialClearance = measurements.plastic_bottom_cutting_clearance
  }
  const clearanceBetweenFabricAndInnerBottom = parseFloat(measurements.fabric_cutting_clearance) - materialClearance
  const tileCutWidthClearance = parseFloat(options.tile_cut_width_clearance)
  const fabricTileCutMeasurment = (options.tile_cut_width - (tileCutWidthClearance + bottomEndCapClearance))- clearanceBetweenFabricAndInnerBottom
  return roundToOneDecimalPlace(fabricTileCutMeasurment)
}

function returnInsideZebraFabricWidth(options, measurements) {
 return options.tile_cut_width
  ? returnInsideZebraFabricWidthTileCut(options, measurements)
  : returnInsideZebraFabricWidthWithoutTileCut(options, measurements)
}

function returnInsideZebraFabricWidthWithoutTileCut(options, measurements) {
  let totalClearance =  parseFloat(options.width_clearance) + parseFloat(measurements.fabric_cutting_clearance)
  const requiresExtraFabricCuttingClearance = parseFloat(options.drop) >= 240;
  if (requiresExtraFabricCuttingClearance) {
    totalClearance += parseFloat(measurements.extra_fabric_cutting_clearance)
  }
  return roundToOneDecimalPlace(parseFloat(options.width) - totalClearance);
}

function returnInsideZebraFabricWidthTileCut(options, measurements) {
  const innerBottomEndCapClearance = 1.1
  const clearanceBetweenFabricAndInnerBottom = parseFloat(measurements.fabric_cutting_clearance) - parseFloat(measurements.alum_inner_bottom_cutting_clearance)
  const tileCutWidthClearance = parseFloat(options.tile_cut_width_clearance)
  const fabricTileCutMeasurment = (options.tile_cut_width - (tileCutWidthClearance + innerBottomEndCapClearance))- clearanceBetweenFabricAndInnerBottom
  return roundToOneDecimalPlace(fabricTileCutMeasurment)
}

function returnFabricArray(options, measurements, blindType, recessType, fixingType) {
    const fabricArray = []
    let tempFabricCuttingClearance = parseFloat(measurements.fabric_cutting_clearance)
    if (blindType.includes('roller') || blindType.includes('zebra')) {
        if ((parseFloat(options.drop) + (options.overlap_drop ? parseFloat(options.overlap_drop) : 0)) > 240) {
            tempFabricCuttingClearance = parseFloat(tempFabricCuttingClearance) + parseFloat(measurements.extra_fabric_cutting_clearance)
        }
    }

    if (blindType.includes('roller')  && recessType.includes('inside')) fabricArray.push({
        title: 'Fabric Cut Width',
        unit: 'cm',
        value: returnInsideRollerFabricWidth(options, measurements, blindType, recessType, fixingType)
    })

    else if (blindType.includes('zebra') && recessType.includes('inside')) fabricArray.push({
        title: 'Fabric Cut Width',
        unit: 'cm',
        value: returnInsideZebraFabricWidth(options, measurements, blindType, recessType, fixingType)
    })

    else fabricArray.push({
        title: 'Fabric Cut Width',
        unit: 'cm',
        value: recessType.includes('outside') ?
            roundToOneDecimalPlace((parseFloat(options.width) + parseFloat(options.overlap_width)) - parseFloat(tempFabricCuttingClearance)) :
            roundToOneDecimalPlace((parseFloat(options.width) - parseFloat(options.width_clearance)) - parseFloat(tempFabricCuttingClearance))
    })

    let dropValue
    if (blindType.includes('roller')) {
        dropValue = recessType.includes('outside') ?
            roundToOneDecimalPlace(parseFloat(options.drop) + parseFloat(options.overlap_drop) + parseFloat(measurements.top_tube_fabric_wrap) + parseFloat(measurements.bottom_bar_fabric_wrap)) :
            roundToOneDecimalPlace(parseFloat(options.drop) + parseFloat(measurements.top_tube_fabric_wrap) + parseFloat(measurements.bottom_bar_fabric_wrap))
    } else if (blindType.includes('zebra')) {
        dropValue = recessType.includes('outside') ?
            roundToOneDecimalPlace((parseFloat(options.drop) * 2) + (parseFloat(options.overlap_drop) * 2) + parseFloat(measurements.top_tube_fabric_wrap)) :
            roundToOneDecimalPlace((parseFloat(options.drop) * 2) + parseFloat(measurements.top_tube_fabric_wrap))
    }

    fabricArray.push({
        title: 'Fabric Cut Drop',
        unit: 'cm',
        value: dropValue
    })

    return fabricArray
}

function returnCordArray(options, blindType, recessType, measurements) {
    const apertureTypeSubtraction = options.aperture_type === 'door' ? 150 : 40
    const cordArray = []
    if (blindType.includes('vertical') || blindType.includes('curtain')) {
        cordArray.push({
            title: 'Slat Qty',
            value: options.slat_qty
        })
        if (options.runner_qty !== undefined && options.runner_qty !== null) {
            cordArray.push({
                title: 'Runner Qty',
                value: options.runner_qty
            })
        }
    }

    if (blindType.includes('curtain')) {
       let dropValue
        if (recessType.includes('outside') && measurements.curtain_fabric) {
            dropValue = parseFloat(options.drop) + parseFloat(options.overlap_drop) - parseFloat(measurements.curtain_fabric)
            cordArray.push({
                title: 'Fabric Cut Drop',
                unit: 'cm',
                value: roundToOneDecimalPlace(dropValue)
            })
        }
        if (recessType.includes('inisde') && measurements.curtain_fabric) {
            dropValue = parseFloat(options.drop) - parseFloat(measurements.curtain_fabric)
            cordArray.push({
                title: 'Fabric Cut Drop',
                unit: 'cm',
                value: roundToOneDecimalPlace(dropValue)
            })
        }
    }

    return cordArray
}

function returnChainArray(options, recessType) {
    const apertureTypeSubtraction = options.aperture_type === 'door' ? 150 : 40
    const chainArray = []
    chainArray.push({
        title: 'Cord',
        unit: 'cm',
        value: roundToOneDecimalPlace((parseFloat(returnFinalBlindWidth(options, recessType)) * 2) + (parseFloat(returnFinalBlindDrop(options, recessType)) * 2) - parseFloat(apertureTypeSubtraction))
    })
    chainArray.push({
        title: 'Chain',
        unit: 'cm',
        value: roundToOneDecimalPlace((parseFloat(returnFinalBlindDrop(options, recessType)) * 2) - parseFloat(apertureTypeSubtraction))
    })

    return chainArray
}

function returnWandArray(options, blindType, recessType, measurements) {
    const wandArray = []
    let dropValue
    if (blindType.includes('curtain')) {
        if (recessType.includes('outside') && measurements.curtain_fabric) {
            dropValue = parseFloat(options.drop) + parseFloat(options.overlap_drop) - parseFloat(measurements.curtain_fabric)

            wandArray.push({
                title: 'Fabric Cut Drop',
                unit: 'cm',
                value: roundToOneDecimalPlace(dropValue)
            })

            wandArray.push({
                title: '',
                unit: '',
                value: null
            })
        }
    }

    if (blindType.includes('vertical') || blindType.includes('curtain')) {
        wandArray.push({
            title: 'Slat Qty',
            value: options.slat_qty
        })

        if (options.runner_qty !== undefined && options.runner_qty !== null) {
            wandArray.push({
                title: 'Runner Qty',
                value: options.runner_qty
            })
        }
    }

    return wandArray
}

function returnVenetianMeasurementsArray(options, measurements, blindType, recessType, fixingType) {
    const venetianMeasurementsArray = []
    const subtractBottomBy = options.wind_stopper_set === 'Yes' ? parseFloat(measurements.wind_stop_set_cutting_clearance) : parseFloat(measurements.metal_head_rail_cutting_clearance)
    venetianMeasurementsArray.push({
        title: 'Head Rail',
        unit: 'cm',
        value: roundToOneDecimalPlace((returnFinalBlindWidth(options, recessType)) - parseFloat(measurements.metal_head_rail_cutting_clearance))
    })
    venetianMeasurementsArray.push({
        title: 'Head Rail Punches',
        value: getHoleAmount(options, recessType)
    })
    venetianMeasurementsArray.push({
        title: 'Head Rail Tilt Rod',
        unit: 'cm',
        value: roundToOneDecimalPlace((returnFinalBlindWidth(options, recessType)) + 3)
    })
    venetianMeasurementsArray.push({
        title: 'Bottom',
        unit: 'cm',
        value: roundToOneDecimalPlace((returnFinalBlindWidth(options, recessType)) - subtractBottomBy)
    })
    venetianMeasurementsArray.push({
        title: 'Slat Qty',
        value: options.slat_qty
    })
    venetianMeasurementsArray.push({
        title: 'Slat Width',
        unit: 'cm',
        value: roundToOneDecimalPlace(returnFinalBlindWidth(options, recessType))
    })
    venetianMeasurementsArray.push({
        title: 'Cord',
        unit: 'cm',
        value: roundToOneDecimalPlace(getCordAmount(options, recessType))
    })

    return venetianMeasurementsArray

}

function getHoleAmount(options, recessType) {
    let width = returnFinalBlindWidth(options, recessType)
    if (width > 0 && width <= 85) {
        return '2 Holes'
    } else if (width > 86 && width <= 140) {
        return '3 Holes'
    } else if (width > 140 && width <= 195)
        return '4 Holes'
    else if (width > 195 && width <= 250)
        return '5 Holes'
}

function getCordAmount(options, recessType) {
    let width = returnFinalBlindWidth(options, recessType)
    let drop = returnFinalBlindDrop(options, recessType)
    if (width > 0 && width <= 85) {
        return width + (drop * 4)
    } else if (width > 86 && width <= 140) {
        return width + (drop * 4)
    } else if (width > 140 && width <= 195)
        return width + (drop * 8)
    else if (width > 195 && width <= 250)
        return width + (drop * 6)
}
